import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Colors } from '../utilities/Colors';

const Legend = () => (
  <Box display="flex" alignItems="center" aria-label="legend-box" sx={{ m: 1 }}>
    <Typography variant="caption">
      <FormattedMessage id="legend.title" />
      :
      {' '}
    </Typography>
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 2,
        '& p': {
          ml: 1,
        },
      }}
      aria-label="legend-item"
    >
      <Box sx={{ width: 10, height: 10, backgroundColor: Colors.correct }} />
      <Typography variant="caption" component="p"><FormattedMessage id="legend.correct" /></Typography>
    </Box>
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 2,
        '& p': {
          ml: 1,
        },
      }}
      aria-label="legend-item"
    >
      <Box sx={{ width: 10, height: 10, backgroundColor: Colors.acceptable }} />
      <Typography variant="caption" component="p"><FormattedMessage id="legend.acceptable" /></Typography>
    </Box>
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 2,
        '& p': {
          ml: 1,
        },
      }}
      aria-label="legend-item"
    >
      <Box sx={{ width: 10, height: 10, backgroundColor: Colors.wrong }} />
      <Typography variant="caption" component="p"><FormattedMessage id="legend.false" /></Typography>
    </Box>
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 2,
        '& p': {
          ml: 1,
        },
      }}
      aria-label="legend-item"
    >
      <Box sx={{ width: 10, height: 10, backgroundColor: Colors.reviewed }} />
      <Typography variant="caption" component="p"><FormattedMessage id="legend.review" /></Typography>
    </Box>
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 2,
        '& p': {
          ml: 1,
        },
      }}
      aria-label="legend-item"
    >
      <Box sx={{ width: 10, height: 10, bgcolor: Colors.dismissed }} />
      <Typography variant="caption" component="p"><FormattedMessage id="legend.dismissed" /></Typography>
    </Box>
  </Box>
);

export default Legend;
